// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"89":"forgot","535":"login","966":"dashboard"}[chunkId] || chunkId) + "." + {"88":"13eeda80","89":"2541fa62","535":"7a31f36d","966":"ed803b3e"}[chunkId] + ".css";
};